import * as React from "react"

export default function FollowerSolidIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.332 14.668a5.333 5.333 0 1110.667 0H1.332zm5.333-6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm4.909 1.489a5.003 5.003 0 013.747 4.511h-1.989c0-1.74-.667-3.324-1.758-4.511zm-1.349-1.518A5.32 5.32 0 0012 4.668a5.31 5.31 0 00-.677-2.602 3.333 3.333 0 01-1.097 6.573z"
        fill={props.fill}
      />
    </svg>
  )
}
